// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-button-ULgKj1{cursor:pointer;text-align:center;border:1px solid;border-color:rgba(var(--coze-stroke-5),var(--coze-stroke-5-alpha));background-color:rgba(var(--coze-bg-1),var(--coze-bg-1-alpha));height:32px;color:rgba(var(--coze-fg-3),var(--coze-fg-3-alpha));border-radius:8px;padding:6px 16px;font-size:14px;font-weight:500;line-height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card-button": `card-button-ULgKj1`,
	"cardButton": `card-button-ULgKj1`
};
export default ___CSS_LOADER_EXPORT___;
